import React from "react";
import useSalesForceChat from "utils/useSalesforceChat";

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    isSalesforceChatLoaded?: boolean;
  }
}

export default function SalesforceProvider({
  children,
  enabled,
}: {
  children: React.ReactNode;
  enabled: boolean;
}) {
  const { setLoadSalesForceScript, loadSalesForceScript } = useSalesForceChat();

  React.useEffect(() => {
    if (!enabled) return;
    window.addEventListener("onEmbeddedMessagingReady", () => {
      // Flag to indicate whether the Salesforce script has been successfully loaded
      window.isSalesforceChatLoaded = true;
    });
  }, []);

  React.useEffect(() => {
    if (!enabled) return;
    setLoadSalesForceScript(true);
  }, [setLoadSalesForceScript]);

  return <>{children}</>;
}
